/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { MyProfileContactDetailsUpdateEmailAddressResponseViewModel } from '../models/my-profile-contact-details-update-email-address-response-view-model';
import { MyProfileContactDetailsUpdateEmailAddressViewModel } from '../models/my-profile-contact-details-update-email-address-view-model';
import { MyProfileContactDetailsUpdateEmailCommunicationViewModel } from '../models/my-profile-contact-details-update-email-communication-view-model';
import { MyProfileContactDetailsUpdateMobileCommunicationViewModel } from '../models/my-profile-contact-details-update-mobile-communication-view-model';
import { MyProfileContactDetailsUpdateMobileNumberResponseViewModel } from '../models/my-profile-contact-details-update-mobile-number-response-view-model';
import { MyProfileContactDetailsUpdateMobileNumberViewModel } from '../models/my-profile-contact-details-update-mobile-number-view-model';
import { MyProfileContactDetailsViewModel } from '../models/my-profile-contact-details-view-model';
import { MyProfileInvoiceSettingsBankViewModel } from '../models/my-profile-invoice-settings-bank-view-model';
import { MyProfileInvoiceSettingsMainAddressViewModel } from '../models/my-profile-invoice-settings-main-address-view-model';
import { MyProfileInvoiceSettingsRegisterBankViewModel } from '../models/my-profile-invoice-settings-register-bank-view-model';
import { MyProfileInvoiceSettingsUpdateAddressResponseViewModel } from '../models/my-profile-invoice-settings-update-address-response-view-model';
import { MyProfileInvoiceSettingsUpdateAddressViewModel } from '../models/my-profile-invoice-settings-update-address-view-model';
import { MyProfileInvoiceSettingsUpdateInvoiceIntervalResponseViewModel } from '../models/my-profile-invoice-settings-update-invoice-interval-response-view-model';
import { MyProfileInvoiceSettingsUpdateInvoiceIntervalViewModel } from '../models/my-profile-invoice-settings-update-invoice-interval-view-model';
import { MyProfileInvoiceSettingsViewModel } from '../models/my-profile-invoice-settings-view-model';

@Injectable({
  providedIn: 'root',
})
export class MyProfileElementService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation elementsMyProfileContactDetailsGet
   */
  static readonly ElementsMyProfileContactDetailsGetPath = '/elements/my-profile/contact-details';

  /**
   * Get contact information for the logged in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyProfileContactDetailsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyProfileContactDetailsGet$Response(params?: {
  }): Observable<StrictHttpResponse<MyProfileContactDetailsViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyProfileElementService.ElementsMyProfileContactDetailsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyProfileContactDetailsViewModel>;
      })
    );
  }

  /**
   * Get contact information for the logged in user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyProfileContactDetailsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyProfileContactDetailsGet(params?: {
  }): Observable<MyProfileContactDetailsViewModel> {

    return this.elementsMyProfileContactDetailsGet$Response(params).pipe(
      map((r: StrictHttpResponse<MyProfileContactDetailsViewModel>) => r.body as MyProfileContactDetailsViewModel)
    );
  }

  /**
   * Path part for operation elementsMyProfileContactDetailsEmailEmailAddressPut
   */
  static readonly ElementsMyProfileContactDetailsEmailEmailAddressPutPath = '/elements/my-profile/contact-details/email/email-address';

  /**
   * Update contact information email address for the currently logged in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyProfileContactDetailsEmailEmailAddressPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  elementsMyProfileContactDetailsEmailEmailAddressPut$Json$Response(params?: {
    body?: MyProfileContactDetailsUpdateEmailAddressViewModel
  }): Observable<StrictHttpResponse<MyProfileContactDetailsUpdateEmailAddressResponseViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyProfileElementService.ElementsMyProfileContactDetailsEmailEmailAddressPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyProfileContactDetailsUpdateEmailAddressResponseViewModel>;
      })
    );
  }

  /**
   * Update contact information email address for the currently logged in user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyProfileContactDetailsEmailEmailAddressPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  elementsMyProfileContactDetailsEmailEmailAddressPut$Json(params?: {
    body?: MyProfileContactDetailsUpdateEmailAddressViewModel
  }): Observable<MyProfileContactDetailsUpdateEmailAddressResponseViewModel> {

    return this.elementsMyProfileContactDetailsEmailEmailAddressPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<MyProfileContactDetailsUpdateEmailAddressResponseViewModel>) => r.body as MyProfileContactDetailsUpdateEmailAddressResponseViewModel)
    );
  }

  /**
   * Update contact information email address for the currently logged in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyProfileContactDetailsEmailEmailAddressPut$CspReport()` instead.
   *
   * This method sends `application/csp-report` and handles request body of type `application/csp-report`.
   */
  elementsMyProfileContactDetailsEmailEmailAddressPut$CspReport$Response(params?: {
    body?: MyProfileContactDetailsUpdateEmailAddressViewModel
  }): Observable<StrictHttpResponse<MyProfileContactDetailsUpdateEmailAddressResponseViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyProfileElementService.ElementsMyProfileContactDetailsEmailEmailAddressPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/csp-report');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyProfileContactDetailsUpdateEmailAddressResponseViewModel>;
      })
    );
  }

  /**
   * Update contact information email address for the currently logged in user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyProfileContactDetailsEmailEmailAddressPut$CspReport$Response()` instead.
   *
   * This method sends `application/csp-report` and handles request body of type `application/csp-report`.
   */
  elementsMyProfileContactDetailsEmailEmailAddressPut$CspReport(params?: {
    body?: MyProfileContactDetailsUpdateEmailAddressViewModel
  }): Observable<MyProfileContactDetailsUpdateEmailAddressResponseViewModel> {

    return this.elementsMyProfileContactDetailsEmailEmailAddressPut$CspReport$Response(params).pipe(
      map((r: StrictHttpResponse<MyProfileContactDetailsUpdateEmailAddressResponseViewModel>) => r.body as MyProfileContactDetailsUpdateEmailAddressResponseViewModel)
    );
  }

  /**
   * Path part for operation elementsMyProfileContactDetailsEmailSubscribePut
   */
  static readonly ElementsMyProfileContactDetailsEmailSubscribePutPath = '/elements/my-profile/contact-details/email/subscribe';

  /**
   * Update contact information email subscription for the currently logged in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyProfileContactDetailsEmailSubscribePut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  elementsMyProfileContactDetailsEmailSubscribePut$Json$Response(params?: {
    body?: MyProfileContactDetailsUpdateEmailCommunicationViewModel
  }): Observable<StrictHttpResponse<MyProfileContactDetailsUpdateEmailCommunicationViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyProfileElementService.ElementsMyProfileContactDetailsEmailSubscribePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyProfileContactDetailsUpdateEmailCommunicationViewModel>;
      })
    );
  }

  /**
   * Update contact information email subscription for the currently logged in user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyProfileContactDetailsEmailSubscribePut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  elementsMyProfileContactDetailsEmailSubscribePut$Json(params?: {
    body?: MyProfileContactDetailsUpdateEmailCommunicationViewModel
  }): Observable<MyProfileContactDetailsUpdateEmailCommunicationViewModel> {

    return this.elementsMyProfileContactDetailsEmailSubscribePut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<MyProfileContactDetailsUpdateEmailCommunicationViewModel>) => r.body as MyProfileContactDetailsUpdateEmailCommunicationViewModel)
    );
  }

  /**
   * Update contact information email subscription for the currently logged in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyProfileContactDetailsEmailSubscribePut$CspReport()` instead.
   *
   * This method sends `application/csp-report` and handles request body of type `application/csp-report`.
   */
  elementsMyProfileContactDetailsEmailSubscribePut$CspReport$Response(params?: {
    body?: MyProfileContactDetailsUpdateEmailCommunicationViewModel
  }): Observable<StrictHttpResponse<MyProfileContactDetailsUpdateEmailCommunicationViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyProfileElementService.ElementsMyProfileContactDetailsEmailSubscribePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/csp-report');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyProfileContactDetailsUpdateEmailCommunicationViewModel>;
      })
    );
  }

  /**
   * Update contact information email subscription for the currently logged in user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyProfileContactDetailsEmailSubscribePut$CspReport$Response()` instead.
   *
   * This method sends `application/csp-report` and handles request body of type `application/csp-report`.
   */
  elementsMyProfileContactDetailsEmailSubscribePut$CspReport(params?: {
    body?: MyProfileContactDetailsUpdateEmailCommunicationViewModel
  }): Observable<MyProfileContactDetailsUpdateEmailCommunicationViewModel> {

    return this.elementsMyProfileContactDetailsEmailSubscribePut$CspReport$Response(params).pipe(
      map((r: StrictHttpResponse<MyProfileContactDetailsUpdateEmailCommunicationViewModel>) => r.body as MyProfileContactDetailsUpdateEmailCommunicationViewModel)
    );
  }

  /**
   * Path part for operation elementsMyProfileContactDetailsMobileNumberPut
   */
  static readonly ElementsMyProfileContactDetailsMobileNumberPutPath = '/elements/my-profile/contact-details/mobile/number';

  /**
   * Update contact information mobile number for the currently logged in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyProfileContactDetailsMobileNumberPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  elementsMyProfileContactDetailsMobileNumberPut$Json$Response(params?: {
    body?: MyProfileContactDetailsUpdateMobileNumberViewModel
  }): Observable<StrictHttpResponse<MyProfileContactDetailsUpdateMobileNumberResponseViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyProfileElementService.ElementsMyProfileContactDetailsMobileNumberPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyProfileContactDetailsUpdateMobileNumberResponseViewModel>;
      })
    );
  }

  /**
   * Update contact information mobile number for the currently logged in user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyProfileContactDetailsMobileNumberPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  elementsMyProfileContactDetailsMobileNumberPut$Json(params?: {
    body?: MyProfileContactDetailsUpdateMobileNumberViewModel
  }): Observable<MyProfileContactDetailsUpdateMobileNumberResponseViewModel> {

    return this.elementsMyProfileContactDetailsMobileNumberPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<MyProfileContactDetailsUpdateMobileNumberResponseViewModel>) => r.body as MyProfileContactDetailsUpdateMobileNumberResponseViewModel)
    );
  }

  /**
   * Update contact information mobile number for the currently logged in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyProfileContactDetailsMobileNumberPut$CspReport()` instead.
   *
   * This method sends `application/csp-report` and handles request body of type `application/csp-report`.
   */
  elementsMyProfileContactDetailsMobileNumberPut$CspReport$Response(params?: {
    body?: MyProfileContactDetailsUpdateMobileNumberViewModel
  }): Observable<StrictHttpResponse<MyProfileContactDetailsUpdateMobileNumberResponseViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyProfileElementService.ElementsMyProfileContactDetailsMobileNumberPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/csp-report');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyProfileContactDetailsUpdateMobileNumberResponseViewModel>;
      })
    );
  }

  /**
   * Update contact information mobile number for the currently logged in user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyProfileContactDetailsMobileNumberPut$CspReport$Response()` instead.
   *
   * This method sends `application/csp-report` and handles request body of type `application/csp-report`.
   */
  elementsMyProfileContactDetailsMobileNumberPut$CspReport(params?: {
    body?: MyProfileContactDetailsUpdateMobileNumberViewModel
  }): Observable<MyProfileContactDetailsUpdateMobileNumberResponseViewModel> {

    return this.elementsMyProfileContactDetailsMobileNumberPut$CspReport$Response(params).pipe(
      map((r: StrictHttpResponse<MyProfileContactDetailsUpdateMobileNumberResponseViewModel>) => r.body as MyProfileContactDetailsUpdateMobileNumberResponseViewModel)
    );
  }

  /**
   * Path part for operation elementsMyProfileContactDetailsMobileSubscribePut
   */
  static readonly ElementsMyProfileContactDetailsMobileSubscribePutPath = '/elements/my-profile/contact-details/mobile/subscribe';

  /**
   * Update profile information mobile subscription for the currently logged in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyProfileContactDetailsMobileSubscribePut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  elementsMyProfileContactDetailsMobileSubscribePut$Json$Response(params?: {
    body?: MyProfileContactDetailsUpdateMobileCommunicationViewModel
  }): Observable<StrictHttpResponse<MyProfileContactDetailsUpdateMobileCommunicationViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyProfileElementService.ElementsMyProfileContactDetailsMobileSubscribePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyProfileContactDetailsUpdateMobileCommunicationViewModel>;
      })
    );
  }

  /**
   * Update profile information mobile subscription for the currently logged in user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyProfileContactDetailsMobileSubscribePut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  elementsMyProfileContactDetailsMobileSubscribePut$Json(params?: {
    body?: MyProfileContactDetailsUpdateMobileCommunicationViewModel
  }): Observable<MyProfileContactDetailsUpdateMobileCommunicationViewModel> {

    return this.elementsMyProfileContactDetailsMobileSubscribePut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<MyProfileContactDetailsUpdateMobileCommunicationViewModel>) => r.body as MyProfileContactDetailsUpdateMobileCommunicationViewModel)
    );
  }

  /**
   * Update profile information mobile subscription for the currently logged in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyProfileContactDetailsMobileSubscribePut$CspReport()` instead.
   *
   * This method sends `application/csp-report` and handles request body of type `application/csp-report`.
   */
  elementsMyProfileContactDetailsMobileSubscribePut$CspReport$Response(params?: {
    body?: MyProfileContactDetailsUpdateMobileCommunicationViewModel
  }): Observable<StrictHttpResponse<MyProfileContactDetailsUpdateMobileCommunicationViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyProfileElementService.ElementsMyProfileContactDetailsMobileSubscribePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/csp-report');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyProfileContactDetailsUpdateMobileCommunicationViewModel>;
      })
    );
  }

  /**
   * Update profile information mobile subscription for the currently logged in user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyProfileContactDetailsMobileSubscribePut$CspReport$Response()` instead.
   *
   * This method sends `application/csp-report` and handles request body of type `application/csp-report`.
   */
  elementsMyProfileContactDetailsMobileSubscribePut$CspReport(params?: {
    body?: MyProfileContactDetailsUpdateMobileCommunicationViewModel
  }): Observable<MyProfileContactDetailsUpdateMobileCommunicationViewModel> {

    return this.elementsMyProfileContactDetailsMobileSubscribePut$CspReport$Response(params).pipe(
      map((r: StrictHttpResponse<MyProfileContactDetailsUpdateMobileCommunicationViewModel>) => r.body as MyProfileContactDetailsUpdateMobileCommunicationViewModel)
    );
  }

  /**
   * Path part for operation elementsMyProfileInvoiceSettingsGet
   */
  static readonly ElementsMyProfileInvoiceSettingsGetPath = '/elements/my-profile/invoice-settings';

  /**
   * Get invoice settings information for a premise for the logged in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyProfileInvoiceSettingsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyProfileInvoiceSettingsGet$Response(params?: {
    premiseId?: string;
  }): Observable<StrictHttpResponse<MyProfileInvoiceSettingsViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyProfileElementService.ElementsMyProfileInvoiceSettingsGetPath, 'get');
    if (params) {
      rb.query('premiseId', params.premiseId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyProfileInvoiceSettingsViewModel>;
      })
    );
  }

  /**
   * Get invoice settings information for a premise for the logged in user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyProfileInvoiceSettingsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyProfileInvoiceSettingsGet(params?: {
    premiseId?: string;
  }): Observable<MyProfileInvoiceSettingsViewModel> {

    return this.elementsMyProfileInvoiceSettingsGet$Response(params).pipe(
      map((r: StrictHttpResponse<MyProfileInvoiceSettingsViewModel>) => r.body as MyProfileInvoiceSettingsViewModel)
    );
  }

  /**
   * Path part for operation elementsMyProfileInvoiceSettingsPost
   */
  static readonly ElementsMyProfileInvoiceSettingsPostPath = '/elements/my-profile/invoice-settings';

  /**
   * Update invoice address for the currently logged in user either for a specific premise or for all premises.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyProfileInvoiceSettingsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  elementsMyProfileInvoiceSettingsPost$Json$Response(params?: {
    body?: MyProfileInvoiceSettingsUpdateAddressViewModel
  }): Observable<StrictHttpResponse<MyProfileInvoiceSettingsUpdateAddressResponseViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyProfileElementService.ElementsMyProfileInvoiceSettingsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyProfileInvoiceSettingsUpdateAddressResponseViewModel>;
      })
    );
  }

  /**
   * Update invoice address for the currently logged in user either for a specific premise or for all premises.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyProfileInvoiceSettingsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  elementsMyProfileInvoiceSettingsPost$Json(params?: {
    body?: MyProfileInvoiceSettingsUpdateAddressViewModel
  }): Observable<MyProfileInvoiceSettingsUpdateAddressResponseViewModel> {

    return this.elementsMyProfileInvoiceSettingsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<MyProfileInvoiceSettingsUpdateAddressResponseViewModel>) => r.body as MyProfileInvoiceSettingsUpdateAddressResponseViewModel)
    );
  }

  /**
   * Update invoice address for the currently logged in user either for a specific premise or for all premises.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyProfileInvoiceSettingsPost$CspReport()` instead.
   *
   * This method sends `application/csp-report` and handles request body of type `application/csp-report`.
   */
  elementsMyProfileInvoiceSettingsPost$CspReport$Response(params?: {
    body?: MyProfileInvoiceSettingsUpdateAddressViewModel
  }): Observable<StrictHttpResponse<MyProfileInvoiceSettingsUpdateAddressResponseViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyProfileElementService.ElementsMyProfileInvoiceSettingsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/csp-report');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyProfileInvoiceSettingsUpdateAddressResponseViewModel>;
      })
    );
  }

  /**
   * Update invoice address for the currently logged in user either for a specific premise or for all premises.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyProfileInvoiceSettingsPost$CspReport$Response()` instead.
   *
   * This method sends `application/csp-report` and handles request body of type `application/csp-report`.
   */
  elementsMyProfileInvoiceSettingsPost$CspReport(params?: {
    body?: MyProfileInvoiceSettingsUpdateAddressViewModel
  }): Observable<MyProfileInvoiceSettingsUpdateAddressResponseViewModel> {

    return this.elementsMyProfileInvoiceSettingsPost$CspReport$Response(params).pipe(
      map((r: StrictHttpResponse<MyProfileInvoiceSettingsUpdateAddressResponseViewModel>) => r.body as MyProfileInvoiceSettingsUpdateAddressResponseViewModel)
    );
  }

  /**
   * Path part for operation elementsMyProfileInvoiceSettingsMainAddressGet
   */
  static readonly ElementsMyProfileInvoiceSettingsMainAddressGetPath = '/elements/my-profile/invoice-settings/main-address';

  /**
   * Get the main address for the logged in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyProfileInvoiceSettingsMainAddressGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyProfileInvoiceSettingsMainAddressGet$Response(params?: {
  }): Observable<StrictHttpResponse<MyProfileInvoiceSettingsMainAddressViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyProfileElementService.ElementsMyProfileInvoiceSettingsMainAddressGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyProfileInvoiceSettingsMainAddressViewModel>;
      })
    );
  }

  /**
   * Get the main address for the logged in user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyProfileInvoiceSettingsMainAddressGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyProfileInvoiceSettingsMainAddressGet(params?: {
  }): Observable<MyProfileInvoiceSettingsMainAddressViewModel> {

    return this.elementsMyProfileInvoiceSettingsMainAddressGet$Response(params).pipe(
      map((r: StrictHttpResponse<MyProfileInvoiceSettingsMainAddressViewModel>) => r.body as MyProfileInvoiceSettingsMainAddressViewModel)
    );
  }

  /**
   * Path part for operation elementsMyProfileInvoiceSettingsInvoiceIntervalPut
   */
  static readonly ElementsMyProfileInvoiceSettingsInvoiceIntervalPutPath = '/elements/my-profile/invoice-settings/invoice-interval';

  /**
   * Update invoice interval for all premises for the currently logged in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyProfileInvoiceSettingsInvoiceIntervalPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  elementsMyProfileInvoiceSettingsInvoiceIntervalPut$Json$Response(params?: {
    body?: MyProfileInvoiceSettingsUpdateInvoiceIntervalViewModel
  }): Observable<StrictHttpResponse<MyProfileInvoiceSettingsUpdateInvoiceIntervalResponseViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyProfileElementService.ElementsMyProfileInvoiceSettingsInvoiceIntervalPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyProfileInvoiceSettingsUpdateInvoiceIntervalResponseViewModel>;
      })
    );
  }

  /**
   * Update invoice interval for all premises for the currently logged in user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyProfileInvoiceSettingsInvoiceIntervalPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  elementsMyProfileInvoiceSettingsInvoiceIntervalPut$Json(params?: {
    body?: MyProfileInvoiceSettingsUpdateInvoiceIntervalViewModel
  }): Observable<MyProfileInvoiceSettingsUpdateInvoiceIntervalResponseViewModel> {

    return this.elementsMyProfileInvoiceSettingsInvoiceIntervalPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<MyProfileInvoiceSettingsUpdateInvoiceIntervalResponseViewModel>) => r.body as MyProfileInvoiceSettingsUpdateInvoiceIntervalResponseViewModel)
    );
  }

  /**
   * Update invoice interval for all premises for the currently logged in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyProfileInvoiceSettingsInvoiceIntervalPut$CspReport()` instead.
   *
   * This method sends `application/csp-report` and handles request body of type `application/csp-report`.
   */
  elementsMyProfileInvoiceSettingsInvoiceIntervalPut$CspReport$Response(params?: {
    body?: MyProfileInvoiceSettingsUpdateInvoiceIntervalViewModel
  }): Observable<StrictHttpResponse<MyProfileInvoiceSettingsUpdateInvoiceIntervalResponseViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyProfileElementService.ElementsMyProfileInvoiceSettingsInvoiceIntervalPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/csp-report');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyProfileInvoiceSettingsUpdateInvoiceIntervalResponseViewModel>;
      })
    );
  }

  /**
   * Update invoice interval for all premises for the currently logged in user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyProfileInvoiceSettingsInvoiceIntervalPut$CspReport$Response()` instead.
   *
   * This method sends `application/csp-report` and handles request body of type `application/csp-report`.
   */
  elementsMyProfileInvoiceSettingsInvoiceIntervalPut$CspReport(params?: {
    body?: MyProfileInvoiceSettingsUpdateInvoiceIntervalViewModel
  }): Observable<MyProfileInvoiceSettingsUpdateInvoiceIntervalResponseViewModel> {

    return this.elementsMyProfileInvoiceSettingsInvoiceIntervalPut$CspReport$Response(params).pipe(
      map((r: StrictHttpResponse<MyProfileInvoiceSettingsUpdateInvoiceIntervalResponseViewModel>) => r.body as MyProfileInvoiceSettingsUpdateInvoiceIntervalResponseViewModel)
    );
  }

  /**
   * Path part for operation elementsMyProfileInvoiceSettingsPaymentBanksGet
   */
  static readonly ElementsMyProfileInvoiceSettingsPaymentBanksGetPath = '/elements/my-profile/invoice-settings/payment/banks';

  /**
   * Get available banks that support e-invoice as payment method.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyProfileInvoiceSettingsPaymentBanksGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyProfileInvoiceSettingsPaymentBanksGet$Response(params?: {
  }): Observable<StrictHttpResponse<Array<MyProfileInvoiceSettingsBankViewModel>>> {

    const rb = new RequestBuilder(this.rootUrl, MyProfileElementService.ElementsMyProfileInvoiceSettingsPaymentBanksGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MyProfileInvoiceSettingsBankViewModel>>;
      })
    );
  }

  /**
   * Get available banks that support e-invoice as payment method.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyProfileInvoiceSettingsPaymentBanksGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyProfileInvoiceSettingsPaymentBanksGet(params?: {
  }): Observable<Array<MyProfileInvoiceSettingsBankViewModel>> {

    return this.elementsMyProfileInvoiceSettingsPaymentBanksGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MyProfileInvoiceSettingsBankViewModel>>) => r.body as Array<MyProfileInvoiceSettingsBankViewModel>)
    );
  }

  /**
   * Path part for operation elementsMyProfileInvoiceSettingsPaymentRegisterEinvoicePost
   */
  static readonly ElementsMyProfileInvoiceSettingsPaymentRegisterEinvoicePostPath = '/elements/my-profile/invoice-settings/payment/register/einvoice';

  /**
   * Register e-invoice to a bank.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyProfileInvoiceSettingsPaymentRegisterEinvoicePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  elementsMyProfileInvoiceSettingsPaymentRegisterEinvoicePost$Json$Response(params?: {
    body?: MyProfileInvoiceSettingsRegisterBankViewModel
  }): Observable<StrictHttpResponse<MyProfileInvoiceSettingsBankViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyProfileElementService.ElementsMyProfileInvoiceSettingsPaymentRegisterEinvoicePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyProfileInvoiceSettingsBankViewModel>;
      })
    );
  }

  /**
   * Register e-invoice to a bank.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyProfileInvoiceSettingsPaymentRegisterEinvoicePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  elementsMyProfileInvoiceSettingsPaymentRegisterEinvoicePost$Json(params?: {
    body?: MyProfileInvoiceSettingsRegisterBankViewModel
  }): Observable<MyProfileInvoiceSettingsBankViewModel> {

    return this.elementsMyProfileInvoiceSettingsPaymentRegisterEinvoicePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<MyProfileInvoiceSettingsBankViewModel>) => r.body as MyProfileInvoiceSettingsBankViewModel)
    );
  }

  /**
   * Register e-invoice to a bank.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyProfileInvoiceSettingsPaymentRegisterEinvoicePost$CspReport()` instead.
   *
   * This method sends `application/csp-report` and handles request body of type `application/csp-report`.
   */
  elementsMyProfileInvoiceSettingsPaymentRegisterEinvoicePost$CspReport$Response(params?: {
    body?: MyProfileInvoiceSettingsRegisterBankViewModel
  }): Observable<StrictHttpResponse<MyProfileInvoiceSettingsBankViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyProfileElementService.ElementsMyProfileInvoiceSettingsPaymentRegisterEinvoicePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/csp-report');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyProfileInvoiceSettingsBankViewModel>;
      })
    );
  }

  /**
   * Register e-invoice to a bank.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyProfileInvoiceSettingsPaymentRegisterEinvoicePost$CspReport$Response()` instead.
   *
   * This method sends `application/csp-report` and handles request body of type `application/csp-report`.
   */
  elementsMyProfileInvoiceSettingsPaymentRegisterEinvoicePost$CspReport(params?: {
    body?: MyProfileInvoiceSettingsRegisterBankViewModel
  }): Observable<MyProfileInvoiceSettingsBankViewModel> {

    return this.elementsMyProfileInvoiceSettingsPaymentRegisterEinvoicePost$CspReport$Response(params).pipe(
      map((r: StrictHttpResponse<MyProfileInvoiceSettingsBankViewModel>) => r.body as MyProfileInvoiceSettingsBankViewModel)
    );
  }

}
